import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/list', qs.stringify(params))
}

export const getListfixcilumn = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/listfixcolumn', qs.stringify(params))
}

export const getBomslist = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/getBomslist', qs.stringify(params))
}

//删除行
export const deleteData = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/edit', qs.stringify(params))
}

export const edit4Supply = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/edit4Supply', qs.stringify(params))
}
export const auditSupply= (params) => {
  return axios.post(root + '/set/jxcgoodscategory/auditSupply', qs.stringify(params))
}

export const querygoodsv2 = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/querygoodsv2', qs.stringify(params))
}

export const listProductID = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/listProductID', qs.stringify(params))
}

export const saveProductID = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/saveProductID', qs.stringify(params))
}
export const signupload = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/signupload', qs.stringify(params))
}

export const getProductIDParam= (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/getProductIDParam', qs.stringify(params))
}

export const listgoodsframe= (params) => {
  let config = {
    noloading: true
  };
  return axios.post(root + '/set/jxcgoodsdetail/goodsframe', qs.stringify(params),config)
}

export const goodsframebycatname= (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/goodsframebycatname', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/set/jxcgoodsdetail/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/set/jxcgoodsdetail/save', qs.stringify(params))
  }
}

//镜架导入
export const jingjiaupload = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/jingjiaupload', qs.stringify(params))

}
//获取产品类型树
export const getGoodsTree = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/tree', qs.stringify(params))
}

export const updateupandlow = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/updateupandlow', qs.stringify(params))
}

export const getSimpleDetail = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/getsimpledetail', qs.stringify(params))
}

export const updateadvertisement = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/updateadvertisement', qs.stringify(params))
}

//查询当前货品的数量
export const count = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/count', qs.stringify(params))
}

export const list4PriceSet = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/list4PriceSet', qs.stringify(params))
}

export const initBarCode = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/initBarCode', qs.stringify(params))
}

export const getBarCode = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/getBarCode', qs.stringify(params))
}

export const importBarcode = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/importBarcode', qs.stringify(params))
}
export const getBarCodeMul = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/getBarCodeMul', qs.stringify(params))
}
export const getdescreMul = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/getdescreMul', qs.stringify(params))
}


export const getscreen = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/screen', qs.stringify(params), {headers: {"tenantid": params.tenantid}})
}
export const getquerygoodsv2 = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/querygoodsv2', qs.stringify(params), {headers: {"tenantid": params.tenantid}})
}

export const hsave = (params) => {
  return axios.post(root + '/order/jxcglassessell/checkXY', qs.stringify(params))
}

//修改图片随机码
export const updateImg = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/updateImg', qs.stringify(params))
}

export const goodswaitaudit = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/waitaudit', qs.stringify(params))
}

export const newGoods = (params) => {
  return axios.post(root + '/set/jxcgoodscategory/newGoods', qs.stringify(params))
}

export const listgoods4app = (params,ssotoken) => {
  return axios.post(root + '/set/jxcgoodsdetail/listapp', qs.stringify(params), {ssotoken: ssotoken})
}

//========== 语义搜索相关 ==========

//语义搜索
 export const searchSemantic = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/searchSemantic', qs.stringify(params))
}

//AI识别配镜需求
 export const recognizeOrder = (formData) => {
  return axios.post(root + '/set/jxcgoodsdetail/recognizeOrder', formData)
}

//语音转文字
 export const transcribeAudioApi = (formData) => {
  return axios.post(root + '/set/jxcgoodsdetail/transcribeAudio', formData)
}

//图片文字提取
 export const extractImageTextApi = (formData) => {
  return axios.post(root + '/set/jxcgoodsdetail/extractImageText', formData)
}

//重建向量索引
 export const buildVectorIndex = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/buildVectorIndex', qs.stringify(params))
}

//更新单个商品向量
 export const updateVector = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/updateVector', qs.stringify(params))
}

//查询需要初始化的商品列表
export const listNeedVectorInit = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/listNeedVectorInit', qs.stringify(params))
}

//批量初始化商品向量
export const initVectorBatch = (params) => {
  return axios.post(root + '/set/jxcgoodsdetail/initVectorBatch', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/jxcgooddetail.js